import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import { useEffect, useRef } from 'react';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';

const Compare: React.FC = () => {
    const { t } = useLang('dpux.Compare');
    const webpOrJpg = useWebpOrJpg('#delta-pro-ultra-x-Compare');

    const list = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1759214143863/Home%20Standby%20Generators.png',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1759214144571/Home.webp',
            title: t('item1_title'),
            items: [
                {
                    value: t('item1_value1'),
                    key: t('item1_key1'),
                },
                {
                    value: t.rich('item1_value2', {
                        t: (v: string) => <span className="top-text">{v}</span>,
                    }),
                    key: t('item1_key2'),
                },
            ],
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1759214143612/DPUX.png',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1759214144305/DPUX.webp',
            title: t('item2_title'),
            items: [
                {
                    value: t('item2_value1'),
                    key: t('item2_key1'),
                },
                {
                    value: t.rich('item2_value2', {
                        t: (v: string) => <span className="top-text">{v}</span>,
                        s2: (v: string) => <span>{v}</span>,
                        s: (v: string) => <span className="s">{v}</span>,
                    }),
                    key: t('item2_key2'),
                },
            ],
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1759214144063/Traditional%20Residential%20Energy%20Storage%20System.png',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1759214144813/Traditional.webp',
            title: t('item3_title'),
            items: [
                {
                    value: t('item3_value1'),
                    key: t('item3_key1'),
                },
                {
                    value: t.rich('item3_value2', {
                        t: (v: string) => <span className="top-text">{v}</span>,
                    }),
                    key: t('item3_key2'),
                },
            ],
        },
    ];

    /** 动画 */
    const sectionRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!sectionRef.current) return;
        const title = sectionRef.current.querySelector('.compare-title');
        const list = sectionRef.current.querySelector('.compare-list')?.children ?? [];
        const screen = AniContainer.create({
            triggerElement: sectionRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                title?.classList.add('enter');
                setTimeout(() => {
                    for (let i = 0; i < list.length; i++) {
                        setTimeout(() => {
                            list[i].classList.add('enter');
                        }, 60 * i);
                    }
                }, 100);
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    title?.classList.remove('enter');
                    for (let i = 0; i < list.length; i++) {
                        list[i].classList.remove('enter');
                    }
                }
            },
        });
        return () => {
            screen.destroy?.();
        };
    }, []);
    return (
        <>
            <EcoSpace />
            <section
                className={`${css.section} delta-pro-ultra-x-Compare GtmModuleData-section`}
                id="delta-pro-ultra-x-Compare"
                data-section-id={'delta-pro-ultra-x-Compare'}
                data-section-title={t('title')}
                ref={sectionRef}
            >
                <div className="compare-title ani-1">{t('title')}</div>
                <div className="compare-list">
                    {list.map((i, idx) => (
                        <div className={`compare-card ani-1 ${idx === 1 ? 'highlight' : ''}`} key={i.title}>
                            <div className="compare-card-top">
                                <EcoImg pc={webpOrJpg(i.img, i.webp)} alt={i.title} />
                                <div className="compare-card-title">{i.title}</div>
                            </div>
                            <div className="compare-card-items">
                                {i.items.map((j, idx2) => (
                                    <div className="compare-card-item" key={j.key + i.title}>
                                        <div className="compare-card-item-value">{j.value}</div>
                                        <div className="compare-card-item-key">{j.key}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </>
    );
};

export default Compare;
